import { DateToItsTimezone } from '@core/constants/time.defaults';
import { offsetSteps } from '@dashboard/components/map-timeline/timeline.service';
import { IDashboardUiState } from '@dashboard/dashboard-store/dashboard.state';
import moment from 'moment';

const date = undefined;
export const DashboardUiState: IDashboardUiState = {
  selectedVessel: '',
  realtimeIsActive: true,
  fromDate: DateToItsTimezone(moment(date).subtract(2, 'd'), 0),
  toDate: DateToItsTimezone(moment(date), 0),
  timezone: 0,
  tooltipTemplate: '',
  sideBar: {
    isSidebarOpen: false,
    isSidebarHeadExpanded: true,
    isVesselInfoExpaded: false,
    sidebarLoading: false,
    infoExpandedLoading: false,
    activeTab: 'particulars',
  },
  aggregation: {
    size: 30,
    step: 'm',
  },
  offsetStep: offsetSteps['d'],
  vessels: {},
  rightBar: {
    view: 'vesselSearch',
    loading: false,
  },
  map: {
    baseLayers: { label: '', layers: [], icon: '' },
    layers: { label: '', layers: [], icon: '' },
    windLayers: {
      loading: false,
      windyType: null,
    },
    selectedOverlayLayers: [],
    selectedBaseLayer: '0',
    zoom: 3,
    bounds: null,
    vessels: {
      loading: false,
      showName: false,
    },
    dms: {
      enabled: false,
      firstClick: null,
      secondClick: null,
    },
  },
  trace: {
    loading: false,
    traceConfig: [],
    activeConfigId: 1,
  },
};
